import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import "components/Pagination/Pagination.scss";

type PaginationProps = {
  pageSize: number;
  totalPages: number;
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export const Pagination = ({ currentPage, totalPages, onPageChange, totalItems, pageSize }: PaginationProps) => {
  const { t } = useTranslation();

  const getPageNumbers = () => {
    if (totalPages <= 3) return Array.from({ length: totalPages }, (_, i) => i + 1);

    const start = Math.min(Math.max(currentPage - 1, 1), totalPages - 2);
    return [start, start + 1, start + 2];
  };

  const pages = useMemo(() => getPageNumbers(), [currentPage, totalPages]);
  const startItem = totalItems ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(startItem + pageSize - 1, totalItems);

  return (
    <div className="pagination-container">
      <div className="pagination-controls">
        <button type="button" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="nav-button">
          ‹
        </button>

        {pages.map(page => (
          <button key={page} type="button" onClick={() => onPageChange(page)} className={currentPage === page ? "active" : ""}>
            {page}
          </button>
        ))}

        <button type="button" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="nav-button">
          ›
        </button>
      </div>

      <div className="pagination-info">
        {t("v8_results", "Results")}: {startItem}-{endItem}/{totalItems}
      </div>
    </div>
  );
};
